<script lang="ts" setup></script>

<template>
  <div class="text-2xs mb-4 font-bold uppercase"><slot /></div>
</template>
